import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=2745b786&scoped=true&lang=pug"
import script from "./CompanyList.vue?vue&type=script&lang=ts"
export * from "./CompanyList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2745b786",
  null
  
)

export default component.exports